import { Directive, Input, ElementRef, OnInit, Renderer2, HostBinding, HostListener } from '@angular/core';
import { environment } from 'src/environments/environment';
import { explode } from 'src/app/theme/utils/util-functions';
import { DomSanitizer, SafeStyle } from "@angular/platform-browser";

@Directive({
  selector: 'img[imagePreload]',
  host: {
    '(error)': 'updateUrl()',
    '[src]': 'src'
  }
})
export class ImagePreloadDirective implements OnInit {
  private toggle: boolean = false;
  @Input() src: string;
  @Input() imgName: string;
  @Input() imgType: string;
  @Input() imgSize: string;
  // @HostBinding('class') className
  @HostListener('mouseenter')
  onMouseEnter() {
    if (!this.src.includes('category_img_not_found')) {
      this.toggle = true;
    }
  }
  @HostListener('mouseleave')
  onMouseLeave() {
    this.toggle = false;
  }
  @HostBinding('style') get myStyle(): SafeStyle {
    if (!this.src.includes('category_img_not_found')) {
      let style: string = this.toggle ? `background: #cccccc` : '';
      return this.doms.bypassSecurityTrustStyle(style);
    }
  }
  store = null;

  constructor(
    private renderer2: Renderer2,
    private elementRef: ElementRef,
    private doms: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.store = JSON.parse(sessionStorage.getItem('store'));
    this.src = !!this.imgName ? this.getImageFullPath() : this.imgType === "categories" ? this.getAlterNativeCategoryImageFullPath() : this.getAlterNativeImageFullPath();

  }

  updateUrl() {
    if (this.imgType === "vendors") {
      let el: HTMLElement = this.elementRef.nativeElement;
      let vendorSpanTag = this.renderer2.createElement('span');
      let vendorName = this.renderer2.createText(this.elementRef.nativeElement.alt.replace('&amp;', '&'));
      this.renderer2.appendChild(vendorSpanTag, vendorName);
      this.renderer2.appendChild(el.parentNode, vendorSpanTag);
      el.remove();
    } else if (this.imgType === "categories") {
      this.src = this.getAlterNativeCategoryImageFullPath();
    } else {
      this.src = this.getAlterNativeImageFullPath();
    }
  }
  getAlterNativeCategoryImageFullPath() {
    return "assets/images/category_img_not_found.png";
  }
  getAlterNativeImageFullPath() {
    let imgPath = this.imgType === 'singleProduct' ? "assets/images/no_image_found_md.png" : "assets/images/no_image_found.png";
    return imgPath;
  }

  changeImageName() {
    if(typeof(this.imgName) === "object")
    {
      this.imgName = this.imgName?this.imgName[0]:'';
    }
    if (!!this.imgSize) {
      if(this.imgSize=="original"){
        return `original/${this.imgName}`;
      } else {
        let splitedImgName = explode(this.imgName, '.');
        return `${splitedImgName[splitedImgName.length - 2]}_${this.imgSize}.${splitedImgName[splitedImgName.length - 1]}`;
      }
    } else {
      return this.imgName;
    }
  }

  getImageFullPath() {
    let image = "";
    if (this.imgType === "categories") {
      image = `${environment.categoryImageUrl}${this.store['id']}/${this.imgName}`;
    } else if (this.imgType === "vendors") {
      image = `${environment.vendorImageUrl}${this.store['id']}/${this.changeImageName()}`;
    } else if (this.imgType === "products" || this.imgType === 'singleProduct') {
      image = `${environment.imageUrl}${this.store['id']}/${this.changeImageName()}`;
    }
    // else if(this.imgType === "store") {
    //   image = `${environment.storeImageUrl}${this.store['id']}/${this.imgName}`;;
    // }
    return image;
  }

}
